<template>
  <div id="myuser">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a>Manage Users</a>
        </li>
      </ol>
    </div>

    <div class="content login middle">
      <div class="cell">
        <div class="container mb50">
          <div class="row mt20">
            <p class="sub-title text-center">USER MANAGEMENT PANEL</p>
            <div class="col-xs-12">
              <div class="row">
                <div class="col-xs-12 text-center">
                  <el-input
                    v-model="user_query"
                    size="big"
                    suffix-icon="el-icon-search"
                    placeholder="Type to search for a name..."
                    class="mt20"
                  ></el-input>
                </div>
              </div>
            </div>

            <div class="col-xs-12 mt30 mb10">
              <a href="#" data-toggle="modal" data-target="#addnew">
                <span class="iconfont2 icon-g7 button-icon font36 mr20"></span>
                <span class="font18 black text-middle">CREATE A USER</span>
              </a>
              <el-tooltip
                class="item pull-right mt20"
                effect="dark"
                content="Download CSV"
                placement="top"
                v-if="userType != 'dealers'"
              >
                <a class="black mr20" @click="downloadCsv()">
                  <span class="iconfont3 icon-download font20"></span>
                </a>
              </el-tooltip>
            </div>
            <div class="col-xs-12 mb20" v-if="userList">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default" v-if="userType == 'admin'">
                  <div class="panel-heading" role="tab" id="headingOne">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_pending == undefined ||
                        filtered_pending.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseOne"
                    >
                      <span
                        class="iconfont3 icon-dealers button-icon mr20"
                      ></span>
                      PENDING REQUESTS
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseOne"
                    class="panel-collapse collapse"
                    :class="
                      filtered_pending == undefined ||
                      filtered_pending.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w30"></th>
                          <th class="w15">Company Name</th>
                          <th class="w10">Country</th>
                          <th class="w10">City</th>
                          <th class="text-right w15">Date Added</th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in filtered_pending"
                            :key="index"
                          >
                            <td class>{{ i.first_name }} {{ i.last_name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/user/' + i._id"
                                class="black mr20"
                              >
                                <span class="iconfont3 icon-edit font18"></span>
                              </router-link>
                              <a
                                class="black"
                                @click="
                                  delete_user(
                                    i._id,
                                    i.first_name + ' ' + i.last_name
                                  )
                                "
                              >
                                <span
                                  class="iconfont3 icon-delete font18"
                                ></span>
                              </a>
                            </td>
                            <td class>{{ i.company }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.add_date) | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default" v-if="userType == 'admin'">
                  <div class="panel-heading" role="tab" id="headingTwo">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_admin == undefined ||
                        filtered_admin.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseTwo"
                    >
                      <span
                        class="iconfont3 icon-sales-vp button-icon mr20"
                      ></span>
                      ADMIN
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseTwo"
                    class="panel-collapse collapse"
                    :class="
                      filtered_admin == undefined || filtered_admin.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w30"></th>
                          <th class="w15">Company Name</th>
                          <th class="w10">Country</th>
                          <th class="w10">City</th>
                          <th class="text-right w15">Date Added</th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr v-for="(i, index) in filtered_admin" :key="index">
                            <td class>{{ i.first_name }} {{ i.last_name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/user/' + i._id"
                                class="black mr20"
                              >
                                <span class="iconfont3 icon-edit font18"></span>
                              </router-link>
                              <a
                                class="black"
                                @click="
                                  delete_user(
                                    i._id,
                                    i.first_name + ' ' + i.last_name
                                  )
                                "
                              >
                                <span
                                  class="iconfont3 icon-delete font18"
                                ></span>
                              </a>
                            </td>
                            <td class>{{ i.company }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.add_date) | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                    </div>
                  </div>
                </div>

                <div class="panel panel-default" v-if="userType == 'admin'">
                  <div class="panel-heading" role="tab" id="headingThree">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_salesVP == undefined ||
                        filtered_salesVP.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseThree"
                    >
                      <span
                        class="iconfont3 icon-sales-vp button-icon mr20"
                      ></span>
                      SALES VP
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseThree"
                    class="panel-collapse collapse"
                    :class="
                      filtered_salesVP == undefined ||
                      filtered_salesVP.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w30"></th>
                          <th class="w15">Company Name</th>
                          <th class="w10">Country</th>
                          <th class="w10">City</th>
                          <th class="text-right w15">Date Added</th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in filtered_salesVP"
                            :key="index"
                          >
                            <td class>{{ i.first_name }} {{ i.last_name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/user/' + i._id"
                                class="black mr20"
                              >
                                <span class="iconfont3 icon-edit font18"></span>
                              </router-link>
                              <a
                                class="black"
                                @click="
                                  delete_user(
                                    i._id,
                                    i.first_name + ' ' + i.last_name
                                  )
                                "
                              >
                                <span
                                  class="iconfont3 icon-delete font18"
                                ></span>
                              </a>
                            </td>
                            <td class>{{ i.company }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.add_date) | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  class="panel panel-default"
                  v-if="
                    userType == 'admin' ||
                    userType == 'salesvp' ||
                    userType == 'salesmanager'
                  "
                >
                  <div class="panel-heading" role="tab" id="headingFour">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_salesManager == undefined ||
                        filtered_salesManager.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseFour"
                    >
                      <span
                        class="iconfont3 icon-sales button-icon mr20"
                      ></span>
                      SALES MANAGERS
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseFour"
                    class="panel-collapse collapse"
                    :class="
                      filtered_salesManager == undefined ||
                      filtered_salesManager.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w30"></th>
                          <th class="w15">Company Name</th>
                          <th class="w10">Country</th>
                          <th class="w10">City</th>
                          <th class="text-right w15">Date Added</th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in filtered_salesManager"
                            :key="index"
                          >
                            <td class>{{ i.first_name }} {{ i.last_name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/user/' + i._id"
                                class="black mr20"
                              >
                                <span class="iconfont3 icon-edit font18"></span>
                              </router-link>
                              <a
                                class="black"
                                @click="
                                  delete_user(
                                    i._id,
                                    i.first_name + ' ' + i.last_name
                                  )
                                "
                              >
                                <span
                                  class="iconfont3 icon-delete font18"
                                ></span>
                              </a>
                            </td>
                            <td class>{{ i.company }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.add_date) | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  class="panel panel-default"
                  v-if="
                    userType == 'admin' ||
                    userType == 'salesvp' ||
                    userType == 'salesmanager'
                  "
                >
                  <div class="panel-heading" role="tab" id="headingFive">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_distributors == undefined ||
                        filtered_distributors.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseFive"
                    >
                      <span
                        class="iconfont3 icon-distributors button-icon mr20"
                      ></span>
                      PARTNER
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseFive"
                    class="panel-collapse collapse"
                    :class="
                      filtered_distributors == undefined ||
                      filtered_distributors.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w30"></th>
                          <th class="w15">Company Name</th>
                          <th class="w10">Country</th>
                          <th class="w10">City</th>
                          <th class="text-right w15">Date Added</th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in filtered_distributors"
                            :key="index"
                          >
                            <td class>{{ i.first_name }} {{ i.last_name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/user/' + i._id"
                                class="black mr20"
                              >
                                <span class="iconfont3 icon-edit font18"></span>
                              </router-link>
                              <a
                                class="black"
                                @click="
                                  delete_user(
                                    i._id,
                                    i.first_name + ' ' + i.last_name
                                  )
                                "
                              >
                                <span
                                  class="iconfont3 icon-delete font18"
                                ></span>
                              </a>
                            </td>
                            <td class>{{ i.company }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.add_date) | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  class="panel panel-default"
                  v-if="
                    userType == 'admin' ||
                    userType == 'salesvp' ||
                    userType == 'salesmanager' ||
                    userType == 'distributors'
                  "
                >
                  <div class="panel-heading" role="tab" id="headingSix">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_distributorsManager == undefined ||
                        filtered_distributorsManager.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseSix"
                    >
                      <span
                        class="iconfont3 icon-distributors button-icon mr20"
                      ></span>
                      PARTNER MANAGERS
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseSix"
                    class="panel-collapse collapse"
                    :class="
                      filtered_distributorsManager == undefined ||
                      filtered_distributorsManager.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w30"></th>
                          <th class="w15">Company Name</th>
                          <th class="w10">Country</th>
                          <th class="w10">City</th>
                          <th class="text-right w15">Date Added</th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in filtered_distributorsManager"
                            :key="index"
                          >
                            <td class>{{ i.first_name }} {{ i.last_name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/user/' + i._id"
                                class="black mr20"
                              >
                                <span class="iconfont3 icon-edit font18"></span>
                              </router-link>
                              <a
                                class="black"
                                @click="
                                  delete_user(
                                    i._id,
                                    i.first_name + ' ' + i.last_name
                                  )
                                "
                              >
                                <span
                                  class="iconfont3 icon-delete font18"
                                ></span>
                              </a>
                            </td>
                            <td class>{{ i.company }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.add_date) | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  class="panel panel-default"
                  v-if="
                    userType == 'admin' ||
                    userType == 'salesvp' ||
                    userType == 'salesmanager' ||
                    userType == 'distributors' ||
                    userType == 'distributorsmanager'
                  "
                >
                  <div class="panel-heading" role="tab" id="headingSeven">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_dealer == undefined ||
                        filtered_dealer.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseSeven"
                    >
                      <span
                        class="iconfont3 icon-sales-vp button-icon mr20"
                      ></span>
                      DEALER
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseSeven"
                    class="panel-collapse collapse"
                    :class="
                      filtered_dealer == undefined ||
                      filtered_dealer.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w30"></th>
                          <th class="w15">Company Name</th>
                          <th class="w10">Country</th>
                          <th class="w10">City</th>
                          <th class="text-right w15">Date Added</th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in filtered_dealer"
                            :key="index"
                          >
                            <td class>{{ i.first_name }} {{ i.last_name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/user/' + i._id"
                                class="black mr20"
                              >
                                <span class="iconfont3 icon-edit font18"></span>
                              </router-link>
                              <a
                                class="black"
                                @click="
                                  delete_user(
                                    i._id,
                                    i.first_name + ' ' + i.last_name
                                  )
                                "
                              >
                                <span
                                  class="iconfont3 icon-delete font18"
                                ></span>
                              </a>
                            </td>
                            <td class>{{ i.company }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.add_date) | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="addnew"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="resetUser()"
          >
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p class="font18 text-center">CREATE A NEW USER</p>
            <el-form
              :model="add_user"
              ref="userForm"
              status-icon
              :rules="rules"
              :validate-on-rule-change="false"
            >
              <div class="row">
                <div class="col-sm-8 col-sm-offset-2">
                  <table class="table mt30 font12">
                    <tr>
                      <td>Title</td>
                      <td>
                        <el-select v-model="add_user.title" class="w100">
                          <el-option label="Mr" value="Mr"></el-option>
                          <el-option label="Mrs" value="Mrs"></el-option>
                        </el-select>
                      </td>
                    </tr>

                    <tr>
                      <td>First Name</td>
                      <td>
                        <el-form-item prop="first_name">
                          <el-input v-model="add_user.first_name"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>Last Name</td>
                      <td>
                        <el-input v-model="add_user.last_name"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <td>Company</td>
                      <td>
                        <el-input v-model="add_user.company"></el-input>
                      </td>
                    </tr>

                    <tr>
                      <td class="text-middle">Account Type</td>
                      <td class="text-right">
                        <el-form-item prop="type">
                          <el-select v-model="add_user.type" class="w100">
                            <el-option
                              v-bind:key="type"
                              v-for="type of userTypes"
                              class="w100"
                              :value="type"
                              :label="mapUserType(type)"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>Country</td>
                      <td>
                        <!-- <el-input v-model="add_user.country"></el-input> -->
                        <div class="el-input el-input--suffix">
                          <country-select
                            class="el-input__inner"
                            :country="add_user.country"
                            v-model="add_user.country"
                          />
                          <span class="el-input__suffix">
                            <span class="el-input__suffix-inner">
                              <i
                                class="
                                  el-select__caret
                                  el-input__icon
                                  el-icon-arrow-down
                                "
                              ></i>
                            </span>
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>City</td>
                      <td>
                        <el-input v-model="add_user.city"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <td>Currency</td>
                      <td>
                        <el-select v-model="add_user.currency" class="w100">
                          <el-option label="USD" value="USD"></el-option>
                          <el-option label="EUR" value="EUR"></el-option>
                          <el-option label="CNY" value="CNY"></el-option>
                        </el-select>
                      </td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>
                        <el-form-item prop="email">
                          <el-input v-model="add_user.email"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>Phone</td>
                      <td>
                        <el-input v-model="add_user.phone"></el-input>
                      </td>
                    </tr>
                    <tr v-if="userType == 'admin'">
                      <td>Barcode ID</td>
                      <td>
                        <el-form-item prop="barcode_id">
                          <el-input v-model="add_user.barcode_id"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr v-if="userType == 'admin'">
                      <td>ERP-CustomerNo</td>
                      <td>
                        <el-form-item prop="erp_customer_no">
                          <el-input
                            v-model="add_user.erp_customer_no"
                          ></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>Password</td>
                      <td>
                        <el-form-item prop="password">
                          <el-input v-model="add_user.password"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        add_user.type != 'admin' &&
                        this.$store.state.user.type == 'admin'
                      "
                    >
                      <td>File Permissions</td>
                      <td>
                        <el-checkbox-group
                          v-model="add_user.checkedFilePermissions"
                        >
                          <el-checkbox
                            class="black"
                            v-for="permission in filePermissions"
                            :label="permission"
                            :key="permission"
                            >{{ permission }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </td>
                    </tr>
                    <tr>
                      <td>Page Permissions</td>
                      <td>
                        <el-checkbox-group
                          v-model="add_user.checkedPagePermissions"
                        >
                          <el-checkbox
                            class="black"
                            v-for="permission in pagePermissions"
                            :label="permission.value"
                            :key="permission.value"
                            >{{ permission.label }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </td>
                    </tr>
                    <!-- <tr>
                      <td>Configurator Permissions</td>
                      <td>
                        <el-checkbox-group
                          v-model="add_user.checkedConfiguratorPermissions"
                        >
                          <el-checkbox
                            class="black"
                            v-for="permission in configuratorPermissions"
                            :label="permission"
                            :key="permission"
                            >{{ permission }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </td>
                    </tr> -->
                  </table>
                  <div class="mt50 text-center">
                    <button
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                      class="el-button mr20"
                      @click="resetUser()"
                    >
                      Cancel
                    </button>
                    <el-button
                      type="button"
                      class="el-button el-button--primary"
                      aria-label="Close"
                      @click="add_new_user()"
                      >OK</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/project.css";
import axios from "axios";

export default {
  name: "myuser",
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.userType == "admin") {
        if (typeof value == "undefined" || value.length == 0) {
          callback(new Error("Barcode ID is required"));
        } else if (typeof value != "undefined" && value.length != 2) {
          callback(new Error("Please enter two characters"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var required = (rule, value, callback) => {
      if (typeof value == "undefined" || value.length == 0) {
        callback(new Error("Required"));
      } else {
        callback();
      }
    };
    return {
      userList: null,
      current: {},
      editable_user: {},
      user_query: "",
      timeout: null,
      userTypes: [],
      filePermissions: ["XLS", "JSON", "DXF", "CSV", "PDF"],
      pagePermissions: [ 
        {
          value: "SR",
          label: "Sales Resources"
        }, 
        {
          value: "TR",
          label: "Technical Resources"
        }, {
          value: "SP",
          label: "Sales Pipeline"
        }
      ],
      // configuratorPermissions: ["AXES/TT"],
      add_user: {
        type: "",
        country: "",
        city: "",
        title: "Mr",
        currency: "EUR",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        password: "",
        user_name: "",
        created_by: "",
        barcode_id: "",
        erp_customer_no: "",
        checkedFilePermissions: [],
        checkedPagePermissions: [],
        checkedConfiguratorPermissions: []
      },
      rules: {
        barcode_id: [{ validator: validatePass, trigger: ["blur"] }],
        type: [{ validator: required, trigger: ["blur"] }],
        first_name: [{ validator: required, trigger: ["blur"] }],
        email: [{ validator: required, trigger: ["blur"] }],
        password: [{ validator: required, trigger: ["blur"] }],
      }
    };
  },
  methods: {
    mapUserType(type) {
      return this.$store.state.userTypeMap[type];
    },
    resetUser() {
      this.add_user = {
        type: "",
        country: "",
        city: "",
        title: "Mr",
        currency: "EUR",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        password: "",
        user_name: "",
        created_by: "",
        checkedFilePermissions: [],
        checkedPagePermissions: []
      };
    },
    getData: function () {
      axios
        .get("/user/" + this.$store.state.user._id)
        .then((response) => {
          var PendingRequests = [];
          var Admin = [];
          var SalesVP = [];
          var SalesManager = [];
          var Partner = [];
          var PartnerManager = [];
          var Dealer = [];

          if (
            typeof response.data != "undefined" &&
            Array.isArray(response.data)
          ) {
            response.data.forEach(function (item) {
              if (typeof item.type == "undefined" || item.type == "")
                item.type = "pending";
              if (item.type.toLowerCase() == "pending")
                PendingRequests.push(item);
              else if (item.type.toLowerCase() == "admin") Admin.push(item);
              else if (item.type.toLowerCase() == "salesvp") SalesVP.push(item);
              else if (item.type.toLowerCase() == "salesmanager")
                SalesManager.push(item);
              else if (item.type.toLowerCase() == "distributors")
                Partner.push(item);
              else if (item.type.toLowerCase() == "distributorsmanager")
                PartnerManager.push(item);
              else if (item.type.toLowerCase() == "dealers") Dealer.push(item);
            });
          }
          this.userList = [
            PendingRequests,
            Admin,
            SalesVP,
            SalesManager,
            Partner,
            PartnerManager,
            Dealer,
          ];
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error.response?.data?.error || "Failed to fetch user data"
          });
        });
    },
    async getUserTypes() {
      var response = await axios(
        "/user/usertypes/" + this.$store.state.user.type
      );
      this.userTypes = response.data;
    },
    async downloadCsv() {
      this.loading = true;
      var fileName =
        "BN_" +
        this.$store.state.user.first_name +
        "_" +
        this.$store.state.user.last_name +
        "_users.csv";
      try {
        var response = await axios("/user/csv/" + this.$store.state.user._id, {
          responseType: "blob",
        });
        var blob = response.data;
        this.loading = false;
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) {
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      } catch (err) {
        this.loading = false;
      }
    },
    sendData(index, sort) {
      this.current = this.userList[sort][index];
      this.editable_user = Object.assign({}, this.current);
    },

    add_new_user() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.add_user.created_by = this.$store.state.user._id;
          axios
            .post("/user/", {
              user: this.add_user,
            })
            .then((res) => {
              if (res.data.ok == 1) {
                this.$message({
                  type: "success",
                  message: "Created!",
                });
                this.getData();
                this.resetUser();
              } 
              window.$("#addnew").modal("hide");
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error.response?.data?.error || "Create Failed!",
              });
            });
        }
      });
    },
    delete_user(ID, name) {
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE USER",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/user/" + ID)
              .then((res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  this.getData();
                  done();
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch((error) => {
                this.$message({
                  type: "error",
                  message: error.response?.data?.error || "Delete Failed!",
                });
              });
          } else {
            done();
          }
        },
      });
    },
  },
  mounted() {
    this.getData();
    this.getUserTypes();
  },
  computed: {
    userType: function () {
      return this.$store.state.user.type;
    },
    filtered_pending: function () {
      return this.userList[0].filter((user) => {
        return (
          user.first_name
            .toLowerCase()
            .includes(this.user_query.toLowerCase()) ||
          user.last_name.toLowerCase().includes(this.user_query.toLowerCase())
        );
      });
    },
    filtered_admin: function () {
      return this.userList[1].filter((user) => {
        return (
          user.first_name
            .toLowerCase()
            .includes(this.user_query.toLowerCase()) ||
          user.last_name.toLowerCase().includes(this.user_query.toLowerCase())
        );
      });
    },
    filtered_salesVP: function () {
      return this.userList[2].filter((user) => {
        return (
          user.first_name
            .toLowerCase()
            .includes(this.user_query.toLowerCase()) ||
          user.last_name.toLowerCase().includes(this.user_query.toLowerCase())
        );
      });
    },
    filtered_salesManager: function () {
      return this.userList[3].filter((user) => {
        return (
          user.first_name
            .toLowerCase()
            .includes(this.user_query.toLowerCase()) ||
          user.last_name.toLowerCase().includes(this.user_query.toLowerCase())
        );
      });
    },
    filtered_distributors: function () {
      return this.userList[4].filter((user) => {
        return (
          user.first_name
            .toLowerCase()
            .includes(this.user_query.toLowerCase()) ||
          user.last_name.toLowerCase().includes(this.user_query.toLowerCase())
        );
      });
    },
    filtered_distributorsManager: function () {
      return this.userList[5].filter((user) => {
        return (
          user.first_name
            .toLowerCase()
            .includes(this.user_query.toLowerCase()) ||
          user.last_name.toLowerCase().includes(this.user_query.toLowerCase())
        );
      });
    },
    filtered_dealer: function () {
      return this.userList[6].filter((user) => {
        return (
          user.first_name
            .toLowerCase()
            .includes(this.user_query.toLowerCase()) ||
          user.last_name.toLowerCase().includes(this.user_query.toLowerCase())
        );
      });
    },
  },
  watch: {
    "add_user.type": function (val) {
      if (val == "dealers" || val == "distributorsmanager") {
        this.add_user.barcode_id = this.$store.state.user.barcode_id || "";
      } 
      this.add_user.checkedFilePermissions = this.$store.state.defaultUserFileTypePrivilegies[val];
      this.add_user.checkedPagePermissions = this.$store.state.defaultUserPagePrivilegies;
      this.add_user.checkedConfiguratorPermissions = [];
    },
  },
};
</script>

<style>
</style>
